/**
* @file 运营中心-公司钱包
* */
<template>
  <div id="organizationFlowing">
    <custom-table @list="getInitFn" :labelWidth="140" ref="customTable" :customOptions="customOptions"
                  :columns="columns"
                  has-organization="true"
                  organization-default="true"
                  excel-type="VehicleStationSettle"
                  :summaryList="summaryList"
    >
      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
        </template>

        <template v-else-if="['settleBalance','orderFee'].includes(item.prop)">
           <span class="util-money" v-if="row[item.prop]">{{
               "￥" + row[item.prop]
             }}</span>
          <span v-if="!row[item.prop]">-</span>
        </template>

        <template
            v-else-if="['stationServiceFee','stationChargeFee','nameField1','nameField2','nameField3','nameField4','nameField5','nameField6','nameField7','nameField8','nameField9','nameField10'].includes(item.prop)">
           <span v-if="row[item.prop]">{{
               "￥" + row[item.prop]
             }}</span>
          <span v-if="!row[item.prop]">-</span>
        </template>

        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "organizationFlowing",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/station/settle/vehicle',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          {
            type: 'daytime',
            field: 'Time',
            name: '统计时间',
            value: [new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24, new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24],
            clearable: false,
          },
          {type: "input", field: "licenseNo", name: "车辆号牌", value: ""},
          {type: "input", field: "vehicleNo", name: "车辆编号", value: ""},
          {type: "input", field: "companyName", name: "车辆所属", value: ""},
        ]
      },
      // 表头
      columns: [],
      flowing: '',
      summaryList: []
    }
  },
  methods: {
    async getInitFn(row) {
      const url = "/api/v1/manage/station/settle/item"
      const {code, data} = await this.$axios.get(url, {
        organizationId: row.organizationId
      })
      if (code === 1 && data) {
        this.summaryList = []
        this.columns = [
          {prop: 'licenseNo', label: '车辆号牌'},
          {prop: 'vehicleNo', label: '车辆编号'},
          {prop: "vehicleResponsible", label: "车辆责任人"},
          {prop: "companyName", label: "车辆所属"},
          {prop: "orderPassengerNum", label: "载客人数"},
          {prop: "orderFee", label: "订单流水"},
          {prop: "stationServiceFee", label: "车站劳务费"},
          {prop: "stationChargeFee", label: "车站站务费"},
          {prop: "taxesFee", label: "税费"},
        ]
        this.summaryList = [
          {
            name: "orderPassengerNum"
          },
          {
            name: "orderFee", beforeUnit: '￥'
          },
          {
            name: "stationServiceFee", beforeUnit: '￥'
          },
          {
            name: "stationChargeFee", beforeUnit: '￥'
          },
          {
            name: "taxesFee", beforeUnit: '￥'
          }
        ]
        data.forEach((item) => {
          this.columns.push({
            prop: item.nameField, label: item.name
          })

          this.summaryList.push({
            name: item.nameField, beforeUnit: '￥'
          })
        })
        this.columns.push({
          prop: 'settleBalance', label: '结算余额', fixed: 'right'
        })
        this.summaryList.push({
          name: 'settleBalance', beforeUnit: '￥'
        })

      }
    },
    /**
     * 状态改变
     */
    statusChange() {
      this.customOptions.params.page = 1
      this.$refs.customTable.listFn();
    }
  }
}
</script>

<style scoped>

</style>
